<template>
    <form @submit="submitForm" class="c-single-field-prompt-form" novalidate>
        <b-form-group :label="title">
            <p ref="label" v-html="label"></p>
            <div class="input-group" :class="{ 'is-invalid': isInvalid }" :aria-hidden="!isInvalid" role="alert" aria-atomic="true">
                <div class="invalid-feedback" id="invalid_feedback"><p>{{ translations.validation }}</p></div>
            </div>
            <div class="custom-control custom-radio" :class="{ 'is-invalid': isInvalid }" v-for="option in this.config.options" v-bind:key="option.stepKey">
                <input 
                    v-model="selected"
                    type="radio"
                    required :id="inputId + '_radio_' + option.stepKey"
                    :name="inputId + '_radio_'"
                    :class="{ 'is-invalid': isInvalid }"
                    class="custom-control-input"
                    :value="option.text">

                <label class="custom-control-label" :for="inputId + '_radio_' + option.stepKey" v-html="option.text"></label>
            </div>
             
        </b-form-group>

        <button type="submit" class="btn btn-round btn-lg btn-danger" :disabled=!isFormValid>{{ translations.submit }}</button>
    </form>
</template>

<script>
    import idMixin from '@/mixins/aha-id';
    import registerEvent from '@/resources/register-event.js';
    import pageGoalsMixin from '@/mixins/page-goals';

    export default {
        mixins: [idMixin, pageGoalsMixin],
        inject: ['EventBus'],
        props: {
            translations: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                default: ""
            },
            label: {
                type: String,
                default: ""
            },
            config: {
                type: Object,
                required: true
            },
            eventText: {
                type: String,
                default: ""
            },
            eventItemId: {
                type: String
            },
            eventDatasourceId: {
                type: String
            },
            bypassCard: {
                type: Boolean,
                default: false
            },
            goals: {
                type: String,
                required: false
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.EventBus.$emit('registerInput', this.config.initialKey, this.$el.querySelectorAll(`[name="${this.inputId + '_radio_'}"]`));
                });
                 //Remove p tag if empty
                const fLabel = this.$refs.label;
                if(fLabel.innerHTML === ''){
                    fLabel.parentNode.removeChild(fLabel);
                }
                //Remove role from fieldset
                // this.$el.querySelector('fieldset').removeAttribute('role');
                /*for(var child=this.$el.querySelector('fieldset').firstChild; child!==null; child=child.nextSibling) {
                    if(child.hasAttribute('role')){
                        child.removeAttribute('role');
                        child.removeAttribute('aria-labelledby');
                    }
                }*/
            });
            // Non IE
            /*this.$el.addEventListener('input', (evt) => {
                this.isFormValid = this.$el.checkValidity();
                console.log('Event input');
            });*/

            // IE
            let radios = this.$el.querySelectorAll('input[type="radio"]');
            var that = this;
            Array.prototype.slice.call(radios).forEach(function(item){
                item.addEventListener('click', function(evt) {
                    that.isFormValid = that.$el.checkValidity();
                })
                
            });



        },
        data() {
            return {
                isInvalid: false,
                options: [],
                selected: null,
                isFormValid: false
            };
        },
        methods: {
            submitForm(evt) {
                const selected = this.config.options.find(option => option.text === this.selected);
                let stepKey;

                evt.preventDefault();

                if(typeof selected === 'undefined') {
                    this.isInvalid = true;
                } else {
                    stepKey = parseInt(selected.stepKey, 10);
                    
                    if (this.$props.bypassCard) {
                        if (selected.linkTarget) {
                            window.open(selected.link, selected.linkTarget);
                        }
                        else {
                            window.open(selected.link, "_self");
                        }
                    }
                    else {
                    this.EventBus.$emit('stepTrigger', stepKey);
                    }

                    // Trigger Page Goals (mixins - pageGoalsMixin)
                    if(this.goals) {
                        this.triggerPageGoals(this.goals);
                    }

                    // Send the analytics request
                    registerEvent.post(this.$props.eventItemId, this.$props.eventText + ' $$Response$$ ' + selected.text, this.$props.eventDatasourceId);

                    this.isInvalid = false;

                    /* eslint-disable-next-line */
                    // Reset form if retake 
                    this.$el.reset();
                    this.isFormValid = false;
                }
            }
        },
        computed: {
            inputId: function() {
                return this.safeId('_AHA_field-prompt_');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-single-field-prompt-radio-form.vue